import { ProductCostBreakdown } from './product-cost-breakdown';

export interface ProductCost {
  key: string;
  description: string;

  productCostBreakdown: ProductCostBreakdown[];
}
